// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1___c6d8b8fc15ff6e31c14","cls2":"ResearchInterestTags-cls2__b1227eda698e6abd3dd1 ResearchInterestTags-cls1___c6d8b8fc15ff6e31c14"};